import { render, staticRenderFns } from "./ExtraTask.vue?vue&type=template&id=fc74b240"
import script from "./ExtraTask.vue?vue&type=script&lang=js"
export * from "./ExtraTask.vue?vue&type=script&lang=js"
import style0 from "./ExtraTask.vue?vue&type=style&index=0&id=fc74b240&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports